import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service as AngularService} from "angular-ecmascript/module-helpers";
import Settings from "../providers/settings.provider";
import Service from "../model/service.model";
import ServiceGroup from "../model/servicegroup.model";

export var Name = 'Services';

export class Services extends AngularService {
    static $name = Name;
    static $inject = ['$q', 'Restangular', 'CacheFactory', 'settings'];

    create() {
        // NOOP.
    }

    all() {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('services', this.settings.branch.id)
            .withHttpConfig({cache: this.CacheFactory.get('http')})
            .getList()
            .then((data)=> {
                var data = data.map((serviceData)=> {
                    return this.Restangular.copy(new Service(serviceData));
                });

                defer.resolve(data);
            })
            .catch((err)=> {
                defer.reject(err);
            });

        return defer.promise;
    }

    allGroups() {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('servicegroups', this.settings.branch.id)
            .withHttpConfig({cache: this.CacheFactory.get('http')})
            .getList()
            .then((data)=> {
                var data = data.map((serviceGroupData)=> {
                    return this.Restangular.copy(new ServiceGroup(serviceGroupData));
                });

                defer.resolve(data);
            })
            .catch((err)=> {
                defer.reject(err);
            });

        return defer.promise;
    }

}

var ServicesModule = Angular.module('services-service', ['restangular', Settings.name]);

new Loader(ServicesModule)
    .load(Services);

export default ServicesModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/services.service.js